export const PHOTO_SEARCH_LABEL = 'Search business, medical, diverse';
export const CLEAR_BUTTON_LABEL = 'Clear photo search';

export const IMAGE_PROVIDERS = 'Pexels & Pixabay';

export const POPULAR_SEARCH_TAGS = ['Leadership', 'Finance', 'Education', 'Medical', 'Research', 'Travel'];

export const DEFAULT_HARDCODED_TAGS = ['Business', 'Technology', 'Healthcare', 'People'];

export const RANDOM_TAG = POPULAR_SEARCH_TAGS[Math.floor(Math.random() * POPULAR_SEARCH_TAGS.length)];

// The default time period for a toast component to display the information.
export const TOAST_TIME = 3000;
